import {PrintableCalendarAspectRatios} from "@/enums/PrintableCalendarAspectRatios";
import {OrientationTypes} from "@/enums/OrientationTypes";
import {CalendarStyles} from "@/enums/CalendarStyles";

export default {
  name: "PrintableCalendarListHeader",
  props: {
    facilityLogo: {
      type: String
    },
    isMonth: {
    },
    isWeek: {
      type: Boolean
    },
    is2Weeks: {
      type: Boolean
    },
    isDay: {
      type: Boolean
    },
    calendarStartDay: {
      type: Date
    },
    isCalendarFilteredByWings: {
      type: Boolean
    },
    isPdfHeader: {
      type: Boolean
    },
    isPreviewHeader: {
      type: Boolean
    },
    headerFont: {
      type: String
    },
    headerSize: {
      type: String
    },
    paperFormat: {
      type: String
    },
    pdfOrientation: {
      type: String
    },
    printCalendarStyle: {
      type: String
    },
    careLevels: {
      type: Array
    },
    selectedWingsPrintableCalendar: {
      type: Array
    },
    printableCalendarUrl: {
      type: Object
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    headerSizeModify() {
      if(this.isUSPdf) {
        if(this.isTabloid) {
          return `${Math.round(parseFloat(this.headerSize) / 1.65)}px`;
        }
        return `${Math.round(parseFloat(this.headerSize) / 2.3)}px`;
      } else {
        if(this.isA3) {
          return `${Math.round(parseFloat(this.headerSize) / 1.45)}px`;
        }
        return `${Math.round(parseFloat(this.headerSize) / 2.1)}px`;
      }
    },
    isUSPdf() {
      return this.$store.state.facilityModule.selectedFacility.countryIso === "US";
    },
    isTabloid() {
      return this.paperFormat === PrintableCalendarAspectRatios.tabloid;
    },
    isPdfLandscape() {
      return this.pdfOrientation === OrientationTypes.Landscape;
    },
    isA3() {
      return this.paperFormat === PrintableCalendarAspectRatios.a3;
    },
    isPortrait() {
      return this.pdfOrientation === OrientationTypes.Portrait;
    },
    isPrintList() {
      return this.printCalendarStyle === CalendarStyles.list;
    },
    selectedWings() {
      const wingsIds = this.selectedWingsPrintableCalendar.map(x => x.id);
      const selectedCareLevelIds = this.careLevels
        .filter(level => level.wingsIds.every(id => wingsIds.includes(id)))
        .map(level => level.id);

      const wings = this.selectedWingsPrintableCalendar
        .filter(wing => !wing.careLevelsIds.some(id => selectedCareLevelIds.includes(id)))
        .map(wing => wing.name);

      const careLevels = this.careLevels
        .filter(level => selectedCareLevelIds.includes(level.id))
        .map(level => level.name);

      return `${[...careLevels, ...wings].join(', ')}`;
    }
  }
}